
import React from 'react';
import { ImageWithFallback } from '@/components/common/ImageWithFallback';
import { useIsMobile } from '@/hooks/use-mobile';

interface CTraderLogoProps {
  platformName: string;
}

export const CTraderLogo = ({ platformName }: CTraderLogoProps) => {
  const isMobile = useIsMobile();
  const logoSize = isMobile ? 'h-8 w-8' : 'h-12 w-12';
  
  const getLogo = () => {
    switch(platformName.toLowerCase()) {
      case 'coinstrat pro':
        return 'https://lbvhywxvthwgiebjsrlr.supabase.co/storage/v1/object/public/logoexchangeplatformurl//logo%20coinstrat%20pro.png';
      case 'fxpro':
        return 'https://play-lh.googleusercontent.com/z1qgps1oruxuJnPdEJjK_209y-TI2v0bTQeZf8DxKRz2cR0ULY5-YFzKknA3YzlB7g';
      case 'xm':
        return 'https://play-lh.googleusercontent.com/EPrP4-hkROiDGPmLnMSKaFlfWHCI5HdV1EWXXVnrHezxYK74czgVhPOxn-psu5_T6A';
      case 'ic market':
        return 'https://play-lh.googleusercontent.com/S_LUow-89YSbQdIf0cYK2qWLVOLGCKkRkj9PRlBHzWwE80-znbQZs95TH96cCIbhDA';
      case 'ftmo':
        return 'https://play-lh.googleusercontent.com/Zz9gWxJt7C8wPZ1jd-8O9HMWAkH4KO8OfKvwPinpvZPtYs4RcbC1ckwZQPj4HNB8GQ';
      case 'ai prop':
        return '/lovable-uploads/d8c04af7-018a-4e74-8091-9940d7e03ad7.png';
      default:
        return 'https://play-lh.googleusercontent.com/rZ6p-VXduWWqsOBGpwsyK_ZpNVOYgj8bKlqQGqPbtVwsTAfVk67s3cSLxuXctJBPzZU';
    }
  };

  return (
    <div className={`${logoSize} flex-shrink-0 overflow-hidden rounded-lg border border-border bg-background`}>
      <ImageWithFallback 
        src={getLogo()} 
        alt={`${platformName} logo`} 
        className="h-full w-full object-contain" 
        showSkeleton={true}
        skeletonClassName="bg-muted/50"
        priority="high"
        draggable={false}
      />
    </div>
  );
};
